import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import useAxios from 'axios-hooks';
import isEmpty from 'lodash.isempty';

import { API_URL } from '../../../config/constants';
import { Button } from '../../../components';
import { short, long } from '../common/formatting/date';
import Questionnaire from '../patient-notifications/Questionnaire';

const AssessmentModal = ({ isOpen, onClose, notificationResponse, practice }) => {
	const [{ data: questionnaireResponses, loading: loadingResponses, /* error */ }, loadCareQuestResponses] = useAxios({
		method: 'GET',
		params: {
			filter: JSON.stringify({
				include: [{
					relation: 'care_quest_question',
					scope: {
						include: ['care_quest_answers']
					}
				}, 'care_quest_answer']
			})
		}
	}, { manual: true });

	useEffect(() => {
		if (isOpen && notificationResponse && notificationResponse.care_quest_response_groupId) {
			loadCareQuestResponses({ url: `/care_quest_response_groups/${notificationResponse.care_quest_response_groupId}/care_quest_responses` });
		}
	}, [isOpen, notificationResponse]);

	const handlePrintClicked = () => {
		window.print();
	};

	return (
		<Modal
			isOpen={isOpen}
			contentLabel="Assessment"
			className="modal-dialog ackd-notification-assessment modal-xl"
			overlayClassName="overlay-temp"
		>
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={handlePrintClicked}>
								<em className="fa fa-print"></em>
							</button>
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">Assessment Details</h3>
					</div>
				</div>
				<div className="modal-body">
					{isOpen && notificationResponse && (
						<div className="row">
							<div className="col-sm-4">
								{!isEmpty(practice.logo_image_name) && (
									<img src={`${API_URL}/provider_practice_logos/${practice.id}/download/${practice.logo_image_name}`} style={{ width: '200px', height: 'auto', marginBottom: '1rem' }} />
								)}<br />
								{practice.practice_name}<br />
								{practice.address1}<br />
								{!isEmpty(practice.address2) && (
									<React.Fragment>{practice.address2}<br /></React.Fragment>
								)}
								{practice.city} {practice.state} {practice.zip}<br />
							</div>
							<div className="col-sm-4">
								<dl className="dl-horizontal">
									<dt>Patient Name</dt>
									<dd>{notificationResponse.name_last}, {notificationResponse.name_first} {!isEmpty(notificationResponse.gender) ? `(${notificationResponse.gender})` : ''}</dd>
									<dt>Patient DOB</dt>
									<dd>{short(notificationResponse.birth_dttm)}</dd>
								</dl>
							</div>
							<div className="col-sm-4">
								<dl className="dl-horizontal">
									<dt>Responded By</dt>
									<dd>{!isEmpty(notificationResponse.provider_name_last) ? `${notificationResponse.provider_name_first} ${notificationResponse.provider_name_last} ${notificationResponse.provider_credentials}` : null}</dd>
									<dt>Responded On</dt>
									<dd>{!isEmpty(notificationResponse.provider_response_dttm) && long(notificationResponse.provider_response_dttm)}</dd>
									<dt>Response</dt>
									<dd>
										{isEmpty(notificationResponse.provider_response) ? (
											<em>No reponse given</em>
										) : (
											notificationResponse.provider_response
										)}
									</dd>
								</dl>
							</div>
						</div>
					)}
					{isOpen && notificationResponse && Array.isArray(questionnaireResponses) && !loadingResponses && (
						<React.Fragment>
							<h4>Questionnaire: {notificationResponse.care_quest_group_name}</h4>
							<Questionnaire
								questions={questionnaireResponses.map(({ care_quest_question }) => care_quest_question)}
								responses={questionnaireResponses}
							/>
						</React.Fragment>
					)}
				</div>
				<div className="modal-footer">
					<Button
						title="Close"
						onClick={onClose}
						large
						primary
					/>
				</div>
			</div>
		</Modal>
	);
};

AssessmentModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	notificationResponse: PropTypes.object,
	practice: PropTypes.object,
};

export default AssessmentModal;
